import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  Paper,
  CircularProgress,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
} from "@mui/material";
import authService from "../Auth/AuthService";
import { CardGiftcard } from "@mui/icons-material";

const OrderView = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const url = authService.pathUrl("GET", '/payment/orders')
      const res = await authService.getAuth(url);
      setOrders(res);
      setLoading(false);
    }
    catch (e) {
      console.error("Error fetching order:", e);
      setLoading(false);
    };
  }


  // Filter orders by any matching value
  const filteredOrders = orders?.filter((order) =>
    Object.values(order).some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    )
  );

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!orders) {
    return (
      <Typography color="error" align="center" sx={{ mt: 5 }}>
        Order not found
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ maxWidth: "95%", mx: "auto", mt: 4 }}>
      <Typography variant="h5" sx={{ p: 2 }}>
         <CardGiftcard sx={{ mr: 1 }} />
        Orders Details
      </Typography>

       {/* Search Filter */}
      <TextField
        label="Search Orders"
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      {/* <DataGrid
        rows={filteredOrders}
        columns={columns}
        getRowId={(row) => row.id}
        autoHeight
        disableSelectionOnClick
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        initialState={{
          sorting: {
            sortModel: [{ field: "createdAt", sort: "desc" }],
          },
        }}
      /> */}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell><b>ID</b></TableCell>
            <TableCell><b>Login ID</b></TableCell>
            <TableCell><b>Master Code</b></TableCell>
            <TableCell><b>Plan</b></TableCell>
            <TableCell><b>PaymentId</b></TableCell>
            <TableCell><b>Currency</b></TableCell>
            <TableCell><b>Price</b></TableCell>
            <TableCell><b>Paid</b></TableCell>
            <TableCell><b>Discount</b></TableCell>
            <TableCell><b>Status</b></TableCell>
            <TableCell><b>Created At</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders?.map((order) => (
            <TableRow key={order.id}>
              <TableCell>{order.id}</TableCell>
              <TableCell>{order.loginId}</TableCell>
              <TableCell>{order.masterCode}</TableCell>
              <TableCell>{order.planName}</TableCell>
              <TableCell>{order.paymentId}</TableCell>
              <TableCell>{order.currency}</TableCell>
              <TableCell>{order.priceAmount}</TableCell>
              <TableCell>{order.paidAmount}</TableCell>
              <TableCell>{order.discountAmount}</TableCell>
              <TableCell
                sx={{
                  color:
                    order.status?.toLowerCase() === "paid"
                      ? "green"
                      : order.status?.toLowerCase() === "failed"
                      ? "red"
                      : "orange",
                  fontWeight: "bold",
                }}
              >
                {order.status}
              </TableCell>
              <TableCell>
                {order.createdAt
                  ? new Date(order.createdAt).toLocaleString()
                  : "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderView;
